<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-devrights-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Development Rights Summary</span>
    </div>
    <b-collapse :id="`collapse-devrights-card`" v-model="showCollapse">
      <div class="card-body">
        <LoadingSpinner v-if="rightsLoading" message ='Loading Development Rights' size = '1x'>
        </LoadingSpinner>
        <template v-if="!rightsLoading && developmentRightsSummary">
          <div class="card listing-card">
            <div class="card-body">
              <div class="table-responsive-sm">
                <table class="table rights-features-table mx-auto">
                  <thead>
                    <th></th>
                    <th>Allowed</th>
                    <th>Existing</th>
                    <th>Remaining</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="label-text">Properties (#)</td>
                      <td>
                        {{ developmentRightsSummary.allowedProperties | numberFormatNullIsNA }}
                      </td>
                      <td>
                        {{ developmentRightsSummary.existingProperties | numberFormatNullIsNA }}
                      </td>
                      <td
                          v-bind:class=
                          "{ 'text-danger': developmentRightsSummary.remainingProperties < 0 }"
                          >
                          {{ developmentRightsSummary.remainingProperties | numberFormatNullIsNA }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label-text">Dwelling Units (#)</td>
                      <td>
                        {{ developmentRightsSummary.allowedDwellingUnits | numberFormatNullIsNA }}
                      </td>
                      <td>
                        {{ developmentRightsSummary.existingDwellingUnits | numberFormatNullIsNA }}
                      </td>
                      <td
                          v-bind:class=
                          "{ 'text-danger': developmentRightsSummary.remainingDwellingUnits < 0 }"
                          >
                          {{ developmentRightsSummary.remainingDwellingUnits |
                          numberFormatNullIsNA }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label-text">Finished Area (sq ft)</td>
                      <td>
                        {{ developmentRightsSummary.allowedFinishedArea | numberFormatNullIsNA }}
                      </td>
                      <td>
                        {{ developmentRightsSummary.existingFinishedArea | numberFormatNullIsNA }}
                      </td>
                      <td
                          v-bind:class=
                          "{ 'text-danger': developmentRightsSummary.remainingFinishedArea < 0 }">
                        {{ developmentRightsSummary.remainingFinishedArea | numberFormatNullIsNA }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label-text">Impervious Area (sq ft)</td>
                      <td>
                        {{ developmentRightsSummary.allowedImperviousArea | numberFormatNullIsNA }}
                      </td>
                      <td>
                        {{ developmentRightsSummary.existingImperviousArea | numberFormatNullIsNA }}
                      </td>
                      <td
                          v-bind:class=
                          "{ 'text-danger': developmentRightsSummary.remainingImperviousArea < 0 }">
                        {{ developmentRightsSummary.remainingImperviousArea |
                        numberFormatNullIsNA }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CollapseControl from '@/mixins/CollapseControl';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'DevelopmentRightsSummary',
  data() {
    return {
      loading: false,
      showCollapse: true,
    };
  },
  mixins: [CollapseControl],
  components: {
    LoadingSpinner,
  },
  mounted() {
    this.$store.dispatch('CurrentProject/fetchDevelopmentRightsSummary', {
      projectId: parseInt(this.$route.params.project_id, 10),
      forceFetch: true,
    });
  },
  computed: {
    ...mapState('CurrentProject', {
      rightsLoading: state => state.rightsLoading,
      developmentRightsSummary: state => state.developmentRightsSummary,
    }),
  },
};
</script>
